import { Modal } from "react-bootstrap";
import { Button } from "./Controls/Button";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { CheckCircleFill } from "react-bootstrap-icons";
import {
  ServerRequestsAddToWaitlistRequest,
  WaitlistApi,
} from "./shared/api/axios-client";
import { createApiService } from "./shared/apiConfig";
import { useSetAtom } from "jotai";

export function WaitlistNoticeModal({
  show,
  onCancel,
  requestPayload,
  onWaitlistSuccess
}: {
  show: boolean;
  onCancel: () => void;
  requestPayload: ServerRequestsAddToWaitlistRequest;
  onWaitlistSuccess?: () => void;
}) {
  const waitlistApi = createApiService(WaitlistApi);
  const navigate = useNavigate();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  

  async function handleConfirmWaitlist() {
    try {
      var response = await waitlistApi.addToWaitlist({
        serverRequestsAddToWaitlistRequest: requestPayload,
      });
  
      if (response.data.error)
      {
        toast.error(response.data.error);
        onCancel();
        return;
      }

      // Show success modal instead of toast
      setShowSuccessModal(true);
      
      if (onWaitlistSuccess) {
        onWaitlistSuccess();
      }
    } catch {
      toast.error("An unexpected error occurred. Please try again later.");
      onCancel();
    } 
  }

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
    onCancel();
  };

  return (
    <>
      <Modal show={show} onHide={onCancel} centered>
        <Modal.Header>
          <Modal.Title>Plan Full - Join Waitlist</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Your requested plan is currently full. You'll be placed on the
            waitlist and notified when spaces open.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onCancel}>
            Cancel
          </Button>
          <Button className="btn-main" onClick={handleConfirmWaitlist}>
            Confirm and Join Waitlist
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Success Modal */}
      <Modal show={showSuccessModal} onHide={() => {}} centered backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title> 
            <CheckCircleFill className="flex-shrink-0" style={{ fontSize: "1.5rem", color:"#28a745", marginTop:"-6px" }} />     
             &nbsp; Successfully Added to Waitlist
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>      
          <div className="mb-2 d-flex gap-3 align-items-start">
            <p>
              <span className="fw-bold">You've been successfully added to the waitlist!</span>
              <br />
              <span className="text-secondary fs-7">
                We'll send you an email notification as soon as a space becomes available. 
              </span>
            </p>                                                
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-main" onClick={handleSuccessModalClose}>OK</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
